import styled from 'styled-components';

export const CartPreviewEntryContainer = styled.div`
  background-color: ${Styles.color.white};
  border: 1px solid ${Styles.color.grey.five};
  width: 100%;
  border-radius: ${Styles.borderRadius};
  color: ${Styles.color.black};
  display: flex;
  flex-direction: column;
  padding: 1rem;

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }
`;
